export const beforeTestFAQs = [
    {
        question: 'Is the iACST open for all Classes and Streams?',
        answer: 'iACST is open for students studying in Class 5th, 6th, 7th, 8th, 9th, 10th (SOM & SOE), 11th (SOM & SOE), and 12th (SOM & SOE).',
        type: 'text',
    },
    {
        question: 'What are the exam timings?',
        answer: 'Online exam from 9 AM to 10 PM. Students can enroll at any time in the exam window.',
        type: 'text',
    },
    {
        question:
            'What are the guidelines for appearing in the exam on the same day as registration?',
        type: 'text',
        answer: 'For online exam, students have to complete registration before 9 PM.',
    },
    {
        question:
            'How to update my personal details (like DOB, email ID, and address details) in iACST?',
        type: 'text', 
        answer: 'You can call on the iACST toll-free number <strong>1800-102-2727</strong>, write to <strong><a href="mailto:acstsupport@aesl.in" style="color:#0D1C2A;">acstsupport@aesl.in</a></strong>, or submit your request by filling out the Google Form: <a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank" style="color:#007aff;" >https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get your details updated.',
    },
    {
        question: 'How can I get my Class, Exam date or Stream changed?',
        type: 'text',
        answer: 'You can call on the iACST toll-free number <strong>1800-102-2727</strong>, write to <strong><a href="mailto:acstsupport@aesl.in" style="color:#0D1C2A;" >acstsupport@aesl.in</a></strong>, or submit your request by filling out the Google Form: <a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank" style="color:#007aff;"> https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get your details updated.',
    },
    {
        question:
            "Will I be able to take the exam if my PSID is not created?",
        type: 'text',
        answer: 'Yes, you will be able to take the exam without the PSID.',
    },
    {
        question:
            'What are the supported browsers & operating systems to write IACST Online?',
        type: 'text',
        answer: '<ul><li>Device Support: Mobile, Desktop, Tablet</li><li>Browser Support: Chrome, Samsung Internet, Safari, Edge, Opera, Firefox.</li><li>OS Support: Android (Android 7 and above), Windows (Windows 7,8,8.1,10, 11), Linux, iOS (iOS 12 and above), MacOS (Mac OS 10 and above)</li><ul><li> Windows 7, 8, 8.1, 10, 11: Preferred Browser - Chrome, Edge, Firefox</li><li>Android OS version (7 and above):Preferred Browser - Chrome, Firefox, Samsung Internet browser for Samsung devices</li><li>MAC OS version 10 & above. Preferred browser - Chrome, Safari</li><li>IOS OS version 12 & above. Preferred browser - Chrome, Safari</li><li>Linux. Preferred browser: Chrome</li></ul></ul>',
    },
    {
        question: 'The iACST test is not showing on my dashboard. What should I do?',
        type: 'text',
        answer: 'Please check your details to confirm which test is not visible. The <strong>main iACST test card</strong> will always be visible on the dashboard.<br/>The status of your iACST test card can be one of the following:<ul><li><strong>Missed</strong> - You did not give the exam on your scheduled date</li><li><strong>Upcoming</strong> - Your exam is scheduled for a future date.</li><li><strong>Start Now</strong> - The test is available to start (on the test day).</li><li><strong>Result Awaited</strong> - You have submitted your test, and the result is not yet declared</li><li><strong>View Result</strong> - Your result is available to view.</li></ul>',
    },
    {
        question:
            'I want to take the iACST test in Gujarati. How can I change the language?',
        type: 'text',
        answer: 'The iACST test in Gujarati is available <strong>only in offline mode</strong>. To take the test in Gujarati, please visit your nearest <strong>Aakash centre</strong>. If you need any help, you can contact us at the iACST <strong>toll-free number 1800-102-2727</strong> or email us at <a  href="mailto:acstsupport@aesl.in" target="_blank" style="color:#007aff;"> acstsupport@aesl.in</a>.',
    },
    {
        question:
            'I’m not able to view the questions/images in the test. What should I do?',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs and open the test in a new incognito window in chrome browser. The test attempts will remain intact<br/>Steps to clear cache on Chrome<ul><li>On your computer, open Chrome.</li><li>At the top right, click More.</li><li>Click More tools and then Clear browsing data.</li><li>At the top, choose a time range. To delete everything, select All time.</li><li>Next to "Cookies and other site data" and "Cached images and files," check the boxes.</li><li>Click Clear data</li></ul>',
    },
    {
        question: 'I submitted my test by mistake. What should I do?',
        type: 'text',
        answer: 'You can call on the iACST toll-free number <strong>1800-102-2727</strong>, write to <strong><a href="mailto:acstsupport@aesl.in" style="color:#0D1C2A;" >acstsupport@aesl.in</a></strong>, or submit your request by filling out the Google Form: <a href="https://forms.gle/EA5uzfGmKEzaeg4P8" target="_blank" style="color:#007aff;"> https://forms.gle/EA5uzfGmKEzaeg4P8</a> to get your details updated.',
    },
    {
        question: 'Question not appearing by clicking on the next button',
        type: 'text',
        answer: 'Clear the cache, close all the browser tabs and open the test in a new incognito window in chrome browser. The test attempts will remain intact',
    }
]

export const afterTestFAQs = [
    {
        question: 'What courses are available at Aakash?',
        answer: 'Aakash offers courses for medical, and engineering entrance exams and scholarship exams such as NEET, JEE, Olympiads, NTSE and NSEs. You can take admission in one-year, two-year, three-year or four-year courses. You can download the latest prospectus here.<a href="https://aakash.ac.in/prospectus" target=_blank style="color:#007aff;">(https://aakash.ac.in/prospectus).</a>',
        type: 'text',
    },
    {
        question: 'Can I get a scholarship on Aakash courses?',
        answer: 'We conduct scholarship exams throughout the year through which students can avail of scholarships on the course fee. These scholarship exams are completely online and can be taken online from the comfort of your home. You can appear for these scholarship exams in online or offline mode at any of the Aakash branches/centres as well.',
        type: 'text',
    },
    {
        question: 'How do I find an Aakash center?',
        answer: 'Students can refer to the center address and Google map link mentioned above to locate your nearest Aakash center. Students can  also call on the Branch/center contact numbers for more details.',
        type: 'text',
    },
    {
        question:
            'I have some questions regarding courses and the admission process. Can I talk to someone at Aakash?',
        answer: 'You can call us at <a href="tel:1800-102-2727" style="color:#007aff;">1800-102-2727</a>. Our admission assistance team will answer all your queries.',
        type: 'text',
    },
]

export const MOCKNEET = [
    {
        question: 'Is the Neet mock test open for all Classes and Streams?',
        answer: 'Any NEET 2026 aspirant can register and appear for the mock test.',
        type: 'text',
    },
    {
        question: 'What are the exam timings?',
        answer: 'The NEET mock test timings are 02:00 PM to 5:00 PM (3 Hours)',
        type: 'text',
    },
    {
        question:
            'What are the guidelines for appearing in the exam on the same day as registration?',
        answer: 'A student should register in advance before they can appear for examination.',
        type: 'text',
    },
    {
        question: 'What will be the last date for enrollment?',
        answer: 'The last date for enrollment will be 1 day before the exam date.',
        type: 'text',
    },
    {
        question: 'What will be the admit card release date?',
        answer: 'The admit card will be released two days before the exam date.',
        type: 'text',
    },
    {
        question: 'When will the NEET Mock Test result be declared?',
        answer: 'The result of the NEET Mock Test will be declared on 29th April 2026',
        type: 'text',
    },
    {
        question: 'How should we get the Class/Date/ changed for the student?',
        answer: 'Please visit your nearest Aakash center. In case you need any further assistance, please contact us at the Toll-Free Number: 7303529494',
        type: 'text',
    },
    {
        question:
            "Will I be able to give the exam if the student's PSID is not created?",
        answer: 'Yes, you will be able to give the exam without the PSID.',
        type: 'text',
    },
]

export const IAT = [
    {
        question:
            '1. What is the duration and Medium of the Test?',
        answer: 'The Test will be conducted in English and will have a duration of 3 hours.',
        type: 'text',
    },
    {
        question: '2. Can I reschedule the Test if I miss it?',
        answer: 'Yes, up to 7 days before the exam.',
        type: 'text',
    },
    {
        question: '3. What are the Test timing for the Invictus Ace Test ?',
        type: 'text',
        answer: 'Exam timings for online 4 pm to 8pm, for offline 10 am to 1 PM. Offline Dates- 21st and 28th December 2025. Online Dates- 21st to 28th December 2025',
    },
    {
        question: '4. Can I attempt to write the more than once?',
        type: 'text',
        answer: 'Each candidate is allowed only one attempt to take the test.',
    },
    {
        question:
            '5. What rewards will be given apart from the scholarship in the Invictus Ace Test exam?',
        type: 'text',
        answer: 'In addition to scholarships, students will also be eligible for Cash Rewards upon enrolling in an Invictus Ace Test course / INVICTUS E- School',
    },
    {
        question: '6. How many times can I register using a number?',
        type: 'text',
        answer: 'Students can log in only once using the same mobile number.',
    },
    {
        question:
            "7. How can a student request demographic changes such as name, father's name, date of birth, gender, email ID, or mobile number?",
        type: 'text',
        answer: " Once registered, students cannot change their name, father's name, date of birth, gender, email ID, or mobile number.",
    },
    {
        question: '8. I am unable to log in to Invictus Ace Test using my roll number and password.',
        type: 'text',
        answer: 'Please verify your roll number and password. For any assistance, contact us at 1800-102-2727 or email invictusacesupport@aesl.in',
    },
]

export const JEEMOCK = [
    {
        question: '1. What is the Aakash OPEN MOCK TEST for JEE Main?',
        answer: 'It is a full-length, JEE Main–pattern online test designed to help students assess their readiness, identify weak areas, and experience the exact difficulty and format of the actual exam.',
        type: 'text',
    },
    {
        question: '2. Who can appear for this Open Test?',
        answer: 'Any JEE Main aspirant (Class 12 or 12th pass) can appear. It is open for both Aakash and non-Aakash students.',
        type: 'text',
    },
    {
        question: '3. Is there any registration fee?',
        answer: 'No. The mock test is completely free of cost.',
        type: 'text',
    },
    {
        question: '4. How do I register for the test?',
        answer: 'Students can register through <a href="https://jee-mocktest.aakash.ac.in/mock-jee-exam" style="color: blue; text-decoration: underline; cursor:pointer;">https://jee-mocktest.aakash.ac.in/mock-jee-exam</a>.',
        type: 'text',
    },
    {
        question: '5. What syllabus will the Open Test cover?',
        answer: 'The test strictly follows the latest JEE Main syllabus as prescribed by NTA.',
        type: 'text',
    },
    {
        question: '6. What is the test pattern?',
        answer: 'The test mirrors the official JEE Main pattern, including the number of questions, difficulty level, marking scheme, and total duration.',
        type: 'text',
    },
    {
        question: '7. Will I receive a detailed performance report?',
        answer: 'Yes. Students will receive a comprehensive analytics report, including:<br/>• Score & accuracy<br/>• Chapter-wise performance<br/>• Predicted All-India Rank',
        type: 'text',
    },
    {
        question: '8. Can I attempt the test again?',
        answer: 'No. Each student is allowed one attempt to ensure fairness and authenticity of results.',
        type: 'text',
    },
    {
        question: '9. What if I face technical issues during the test?',
        answer: 'A dedicated technical support team will be available during the test.',
        type: 'text',
    },
    {
        question: '10. When will the exam be held?',
        answer: 'The exam is scheduled for 28th Dec 2025, 4th Jan 2026, and 11th Jan 2026. You must start your exam anytime within the six-hour start window on your chosen exam date (11:00 AM – 5:00 PM).',
        type: 'text',
    },
    {
        question: '11. How do I take the test?',
        answer: 'Use a laptop/desktop or mobile (via Aakash JEE NEET App and Website both) with a stable internet connection and the latest Chrome/Safari browser.',
        type: 'text',
    },
    {
        question: '12. When and how will I get my result?',
        answer: 'After the exam is completed, your score will be released instantly. The detailed results, including your All-India Rank and a comprehensive performance report (covering strengths, weaknesses, opportunities, and threats – SWOT), will be released within 24 to 48 hours.',
        type: 'text',
    },
    {
        question: '13. Will there be negative marking?',
        answer: 'Yes. The marking scheme will follow the official JEE Main pattern, including negative marking in MCQs.',
        type: 'text',
    },
    {
        question: '14. What is the exam mode and medium?',
        answer: 'The exam mode is online and conducted in English & Hindi.',
        type: 'text',
    },
]
